<template>
  <div id="app">

    <Header></Header>
    <div class="spacer"></div>

    <Login
      :isSignedIn="user.isSignedIn"
      v-on:signed-in="signInUser">
    </Login>


    <transition name="fade" mode="out-in">
      <router-view
        :beers="beers"
        :user="user">
      </router-view>
    </transition>

    <Footer
      :user="user"
      v-on:signed-out="signOutUser">
    </Footer>

    <Navbar></Navbar>
  </div>
</template>

<script>
import axios from 'axios'

import Navbar from './components/Navbar.vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Login from './components/Login.vue';

export default {
  name: 'app',
  components: {
    Navbar,
    Header,
    Footer,
    Login,
  },
  data() {
    return {
      beers: [],
      user: {
        id: 0,
        name: '',
        drinkedBeers: [],
        isSignedIn: false,
      },
    }
  },
  methods: {
    signInUser: function(googleUser) {
      let token = googleUser.getAuthResponse().id_token;
      let profile = googleUser.getBasicProfile();
      this.user.name = profile.getName();
      axios.post('https://klogtkryds.dk/studenterbaren/api/checkUser', {
          id_token: token
        })
        .then(res => {
          this.user.id = res.data.data.id;
          this.setDrinkedBeers(res.data.data.id);
        })
        .catch(() => console.log("could not retrieve user"));
      // this.user.basicInfo = googleUser.getBasicProfile();
      this.user.isSignedIn = true;
    },
    signOutUser: function() {
      this.user.isSignedIn = false;
    },

    setDrinkedBeers: function(userid) {
      axios.get('https://klogtkryds.dk/studenterbaren/api/drinkedBeers/'+userid)
        .then(res => this.user.drinkedBeers = res.data.data)
        .catch( () => {this.user.drinkedBeers = []});
    }
  },
  created() {
    // set all beers
    axios.get('https://klogtkryds.dk/studenterbaren/api/beers')
      .then(res => this.beers = res.data.data)
      .catch( () => {this.beers =[{name: 'ingen internetforbindelse', price: 3, abv:1},{name: 'prøv igen senere', price: 2, abv:1}]});

  }

}
</script>

<style>
@import './main.css';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--primaryColor);
}
body{
  margin: 0;
  padding: 0;

}
.spacer{
  height: 80px;
}
</style>
